<template>
  <div>
 
    <p class="section-text section-text-1 fw-500 | margin-bottom-0-5">Welcome back to {{ this.$config.appName }}!</p>
    <h1 class="section-heading section-heading-1 color-primary-400">Continue your dental health journey</h1>

    <form id="account-form" action="#" class="margin-top-3">
      <div class="form-group">
        <label for="email" class="label-style-1">Email</label>
        <div class="position-relative">
          <input v-model="this.user.email" tabindex="1" name="email" type="email" class="input-style-1 has-icon" required />
          <svg class="icon">
            <use xlink:href="@/assets/icons.svg#outline-mail" />
          </svg>
        </div>
      </div>

      <div class="form-group">
        <label class="label-container label-style-1">
          <input v-model="this.user.agreement" tabindex="3" type="checkbox" required />
          <span class="checkmark"></span>
          I agree to the
          <router-link :to="'/terms-of-services' + this.redirectURL" data-redirect="/terms-of-services">terms of services</router-link>
        </label>
      </div>

      <div class="form-group margin-top-4">
        <button class="button button-primary button-block">Reset Password</button>
      </div>

      <div class="form-group">
        <p class="section-text section-text-1 color-neutral-600 fw-500">
          If you have an account, please <router-link to="/login">login here?</router-link>
        </p>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    name: 'ForgotPasswordPage',
    data() {
      return {
        user: {
          email: '',
          agreement: false,
        },
      };
    },

    /**
     * ===== Computed
     */

    computed: {
      redirectURL() {
        let emailEnc = this.$helper.Encryption.encrypt(this.user.email);

        return `?redirect=forgot-password&e=${emailEnc}`;
      },
    },

    /**
     * ===== Methods
     */

    methods: {
      fillForm(query) {
        if (query.e !== undefined && query.e !== '') this.user.email = this.$helper.Encryption.decrypt(query.e);
      },
    },

    /**
     * ===== Hooks
     */

    mounted() {
      this.fillForm(this.$route.query);
    },
  };
</script>

<style></style>
